import { gql } from '@apollo/client'

export const APPROVE_GROUP_CLEARANCE_STATUS = gql`
  mutation ApproveGroupClearanceStatus($inputData: ApproveGroupClearanceStatusInput!) {
    approveGroupClearanceStatus(inputData: $inputData)
  }
`
